<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-26 18:50:14
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="订单备注"
    :visible.sync="dialogVisible_remark"
    width="30%"
    :before-close="handleClose"
  >
    <el-form
      :model="dynamicValimarkForm"
      ref="dynamicValimarkForm"
      class="demo-dynamic"
    >
      <el-form-item prop="remarks">
        <el-input
          type="remarks"
          :rows="3"
          placeholder="请输入备注，限200字"
          v-model="dynamicValimarkForm.remarks"
          maxlength="200"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        :disabled="stepLoading"
        @click="submitForm('dynamicValimarkForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      dynamicValimarkForm: {
        remarks: "",
        orderId: "",
      },
      stepLoading: false,
      dialogVisible_remark: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_remark = this.openStatus;
    },
    orderId(val1, val2) {
      this.dynamicValimarkForm.orderId = val1;
    },
  },
  mounted() {
    this.dynamicValimarkForm.orderId = this.orderId;
  },
  methods: {
    submitForm() {
      this.dynamicValimarkForm.remarks = "";
      this.stepLoading = true;
      this.$http.szOrder
        .editOrderRemarks(this.dynamicValimarkForm)
        .then((res) => {
          this.stepLoading = false;
          if (res.status == 1) {
            this.dialogVisible_remark = false;
            this.$message({
              message: "备注成功",
              type: "success",
            });
            this.$emit("closeStatus", true);
          }
        });
    },
    handleClose() {
      this.dialogVisible_remark = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>